export default __webpack_public_path__ + "static/media/YELLOW_PAGES_SINGAPORE.9d03f7d3.png";